import { PromoCommunicationService } from "../services/PromoCommunicationService";

interface IGameReloadHandler {
    handleReload(): void;
}

const RELOAD_THROTTLE_MS = 100;

export class GameReloadHandler implements IGameReloadHandler {
    private gameReloadCount = 0;
    private lastReloadTime = 0;

    constructor(
        private communicationService: PromoCommunicationService | null = null,
        private isDebug: boolean = false
    ) {}

    public handleReload(): void {
        const now = Date.now();
        const timeSinceLastReload = now - this.lastReloadTime;

        if (timeSinceLastReload < RELOAD_THROTTLE_MS) {
            this.consoleLog(
                "[GameReloadHandler::handleReload]",
                "ignored (throttled, %sms since last)",
                timeSinceLastReload
            );
            return;
        }

        this.lastReloadTime = now;
        this.gameReloadCount++;

        if (this.communicationService && this.canHandleReload()) {
            this.consoleLog(
                "[GameReloadHandler::handleReload]",
                "%s sent to Promo Tool",
                this.gameReloadCount
            );
            this.communicationService.requestGameReload();
            return;
        }

        this.consoleLog(
            "[GameReloadHandler::handleReload]",
            "#%s using fallback reload",
            this.gameReloadCount
        );

        window.location.reload();
    }

    private canHandleReload(): boolean {
        if (this.isDebug) {
            return !!this.communicationService?.isPromoToolInited;
        }
        return !!this.communicationService?.isPromoToolInited;
    }

    private consoleLog = (place: string, message: any, data: any = "") => {
        if (!this.isDebug) {
            return;
        }
        console.log(place, message, data);
    };
}
